import {
  GetPipelineStageProjectsInput,
  PipelineStageProjectsSortBy,
  SortDirection,
} from '@/gql/graphql';
import { ButtonDropdown, Tooltip, type TDropdownItem } from '@payaca/ambrosia';
import { PIPELINE_STAGE_PROJECTS_DEFAULT_SORT } from '@payaca/constants/pipeline';
import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  input?: GetPipelineStageProjectsInput;
  onChangeInput?: React.Dispatch<
    React.SetStateAction<GetPipelineStageProjectsInput | undefined>
  >;
};

type SortOption = {
  label: string;
  sortBy: PipelineStageProjectsSortBy;
  sortDirection: SortDirection;
};

const SORT_OPTIONS: SortOption[] = [
  {
    label: 'Most recently updated',
    sortBy: 'LATEST_ACTIVITY_AT',
    sortDirection: 'DESC',
  },
  {
    label: 'Least recently updated',
    sortBy: 'LATEST_ACTIVITY_AT',
    sortDirection: 'ASC',
  },
  {
    label: 'Least time in stage',
    sortBy: 'ADDED_TO_STAGE',
    sortDirection: 'DESC',
  },
  {
    label: 'Longest time in stage',
    sortBy: 'ADDED_TO_STAGE',
    sortDirection: 'ASC',
  },
];

function PipelineSortControl({ input, onChangeInput }: Props) {
  const currentSortBy =
    input?.sortBy ?? PIPELINE_STAGE_PROJECTS_DEFAULT_SORT.by;
  const currentSortDirection =
    input?.sortDirection ?? PIPELINE_STAGE_PROJECTS_DEFAULT_SORT.direction;

  const sortItems: TDropdownItem[] = SORT_OPTIONS.map((option) => ({
    label: option.label,
    selected:
      currentSortBy === option.sortBy &&
      currentSortDirection === option.sortDirection,
    onClick: () => {
      onChangeInput?.((prev) => ({
        ...prev,
        sortBy: option.sortBy,
        sortDirection: option.sortDirection,
      }));
    },
  }));

  return (
    <ButtonDropdown
      dropdownOptions={{ items: sortItems, anchor: 'start' }}
      variant="secondary"
      size="sm"
      aria-label="Change sort order"
    >
      <UntitledIcon name="switch-vertical-01.3" className="size-4" />
      Sort
    </ButtonDropdown>
  );
}

export default PipelineSortControl;
